export function contractYears(suggestedStartMonth = 11) {
  var years = []

  var currentYear = getCurrentYear(suggestedStartMonth)

  // we start creating contracts for the next year in july
  if ((new Date()).getMonth() > 5) {
    currentYear++
  }
  for (var year = 2020; year <= currentYear; year++) {
    years.push({ value: year, text: year + '' })
  }
  return years
}

export function getCurrentYear(suggestedStartMonth = 11) {
  const thresholdMonthIndex = suggestedStartMonth - 1
  if ((new Date()).getMonth() >= thresholdMonthIndex) {
    return (new Date()).getFullYear() + 1
  }
  return (new Date()).getFullYear()
}

// we don't create contracts / kukos for the current year if it's already december
export function getDefaultStartDate(suggestedStartMonth = 11) {
  const thresholdMonthIndex = suggestedStartMonth - 1
  if ((new Date()).getMonth() >= thresholdMonthIndex) {
    return new Date(new Date().getFullYear() + 1, 0, 1)
  }
  return new Date(new Date().getFullYear(), 0, 1)
}

export function getDefaultEndDate(suggestedStartMonth = 11) {
  const thresholdMonthIndex = suggestedStartMonth - 1
  if ((new Date()).getMonth() >= thresholdMonthIndex) {
    return new Date(new Date().getFullYear() + 1, 11, 31)
  }
  return new Date(new Date().getFullYear(), 11, 31)
}
